
export const API_URLS = {
    ST_RESOURCES: "https://demo1.publishstory.co"
}

export const PAGEBUILDER_URLS = [
    "timesinternet.in",
    "qcdenmark.publishstory.co",
    "pagebuilder.publishprocms.com",
    "pborigin.publishstory.co",
    "pagebuilder.publishstory.co",
    "app.publishstory.co",
    "pb.timesinternet.in",
    "preprod.publishstory.co",
    "denmark.publishstory.co",

    "preproddenmark.timesinternet.in",
    "denmark.timesinternet.in"
]

export const ENDUSER_PAGE = [
    "articlelist",
    "videolist",
    "podcastlist",
    "photolist",
    "webstorylist",
    "articleshow",
    "videoshow",
    "photoshow",
    "liveblog",
    "amp_articleshow",
    "amp_videoshow",
    "amp_photoshow",
    "amp_liveblog",
    "podcast"
];

export const URL_PROTOCAL = "https://";

////console.log("components_constant_env process found BEFORE");
if (typeof process !== 'undefined' && undefined !== process && process && process.env) {
    ////console.log("components_constant_env process found", process);
}



